import { Link } from "react-router-dom";
import { channels } from "@/mocks/channels";

const friendlyLinks = [
  { name: "星海内容", href: "#" },
  { name: "极光赛事", href: "#" },
  { name: "云雀音乐", href: "#" },
  { name: "知了教育", href: "#" },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-live-line text-xl text-background-50" />
              </span>
              <span className="font-heading text-xl font-extrabold text-foreground-950">直播</span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              综合直播平台，汇聚游戏、娱乐、教育、生活、体育与音乐多频道精彩内容，实时在线观看，随时随地发现你喜欢的直播。
            </p>
            <div className="mt-4 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-tiktok-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-md bg-background-50 border border-background-200/70 flex items-center justify-center text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">直播频道</h4>
            <ul className="flex flex-col gap-2.5">
              {channels.map((channel) => (
                <li key={channel.key}>
                  <Link
                    to={`/category/${channel.key}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {channel.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">关于平台</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  联系反馈
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  搜索直播
                </Link>
              </li>
              <li>
                <Link to="/topic/t1" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  精选专题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">友情链接</h4>
            <ul className="flex flex-col gap-2.5">
              {friendlyLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    rel="nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-foreground-500 leading-relaxed">
              本平台内容为演示数据，真实直播流与接口数据待后续接入。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">© 2025 直播 综合直播平台 · 保留所有权利</p>
          <p className="text-xs text-foreground-500">演示站点 · 数据仅供参考</p>
        </div>
      </div>
    </footer>
  );
}